import { faExclamationTriangle, faSync } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";
import React from "react";
import { Helmet } from "react-helmet";

import { Btn, BtnType } from "@/mk2/components/Btn";
import {
    LOAD_ERROR_MESSAGE,
    LOAD_ERROR_RETRY,
    SEO_DESCRIPTION_DEFAULT_FALLBACK,
} from "@/mk/autogenerated/translations/LoadError.6c02654805582d21de8ad9c99948207c";

import styles from "./LoadError.mscss";

interface OwnProps {
    className?: string;
    message?: string;
    changeTitle?: boolean;
    onRetry();
}

export const LoadError: React.StatelessComponent<OwnProps> = ({
    onRetry,
    message,
    changeTitle = true,
    className,
}) => {
    const title = message || LOAD_ERROR_MESSAGE;

    return (
        <div className={cx(styles.LoadError, className)}>
            {changeTitle && (
                <Helmet>
                    <title>{title}</title>
                    <meta property="og:title" content={title} />
                    <meta property="og:description" content={SEO_DESCRIPTION_DEFAULT_FALLBACK} />
                </Helmet>
            )}
            <div className={styles.LoadError__icon}>
                <FontAwesomeIcon icon={faExclamationTriangle} />
            </div>
            <div className={styles.LoadError__message}>{title}</div>
            <div className={styles.LoadError__button}>
                <Btn type={BtnType.Blue} label={LOAD_ERROR_RETRY} icon={faSync} onClick={onRetry} />
            </div>
        </div>
    );
};
